import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const FAQ_ITEMS = [{
  question: '¿Qué recibo al comprar SIC 360?',
  answer: 'Recibís el sistema completo de clases anuales de Sistemas de Información Contable, más 4 bonos exclusivos: Clases Salvavidas (Plan B Docente), Evaluaciones Listas con Rúbricas, Mapa Anual de Contenidos, y Banco de Ejemplos Explicados. Todo en formato digital para descargar inmediatamente.'
}, {
  question: '¿Cuándo me llega?',
  answer: 'El acceso es inmediato. Una vez confirmado el pago, recibís un email con las instrucciones para descargar todo el material. Podés empezar a usarlo en menos de 5 minutos.'
}, {
  question: '¿Cómo lo recibo?',
  answer: 'Todo el material es digital. Después de la compra, te enviamos un link de descarga a tu email. Podés guardar los archivos en tu computadora, tablet o celular, y acceder cuando quieras sin necesidad de internet.'
}, {
  question: '¿Es físico o digital?',
  answer: 'Es 100% digital. No hay envíos físicos. Esto te permite acceder al instante y llevarlo siempre con vos en cualquier dispositivo. Además, podés imprimirlo si preferís trabajar en papel.'
}, {
  question: '¿Necesito ser profesional?',
  answer: 'No necesitás ser contador ni tener título universitario. SIC 360 está diseñado para docentes de nivel secundario que dictan materias relacionadas con contabilidad, economía o administración. Si das clases de SIC, esto es para vos.'
}, {
  question: '¿Tengo acceso para siempre?',
  answer: 'Sí, el acceso es vitalicio. Una vez que descargás el material, es tuyo para siempre. No hay vencimientos, renovaciones ni pagos mensuales. Comprás una vez y lo usás todos los años que quieras.'
}, {
  question: '¿Qué hago si no me llega el acceso?',
  answer: 'Si no recibís el email en los próximos 10 minutos, revisá tu carpeta de spam. Si aún así no lo encontrás, escribinos a soporte y te lo reenviamos de inmediato. Siempre respondemos en menos de 24 horas.'
}, {
  question: '¿Es una compra segura?',
  answer: 'Sí, todas las transacciones se procesan a través de MercadoPago, la plataforma de pagos más segura de Argentina. Tus datos están protegidos y nunca compartimos tu información personal.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleQuestion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 px-4 bg-white" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-31">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-32">
            Resolvé aquí tus <span className="text-orange-600" data-id="element-33">DUDAS</span>
          </h2>
          <p className="text-xl text-gray-600" data-id="element-34">
            Las preguntas más frecuentes sobre el pack
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4" data-id="element-35">
          {FAQ_ITEMS.map((item, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-36">
              <button onClick={() => toggleQuestion(index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-37">
                <span className="font-bold text-gray-900 text-lg pr-4" data-id="element-38">
                  {item.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-orange-600 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-39" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-40">
                <div className="px-6 pb-5 text-gray-700 leading-relaxed" data-id="element-41">
                  {item.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}